module.exports = __webpack_public_path__ + "img/heyan.95dc485b.png";